import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useRemoveUser({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    user_id,
    team_id,
  }: {
    user_id: string
    team_id: string
  }) => {
    const response = await httpClient.post(
      'team/team/remove-user',
      {
        user_id,
      },
      {
        headers: {
          'X-Team': team_id,
        },
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success('User removed successfully')
      //   queryClient.invalidateQueries({ queryKey: ['current-user'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
